export enum ProcessTrackingStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  FAIL = 'FAIL'
}
